var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container calendar-list-container" },
    [
      _c(
        "basic-container",
        [
          _c(
            "avue-crud",
            {
              ref: "crud",
              attrs: {
                option: _vm.tableOption,
                data: _vm.list,
                page: _vm.page,
                "table-loading": _vm.listLoading,
                "before-open": _vm.handleOpenBefore,
              },
              on: {
                "update:page": function ($event) {
                  _vm.page = $event
                },
                "on-load": _vm.getList,
                "search-change": _vm.searchChange,
                "refresh-change": _vm.refreshChange,
                "size-change": _vm.sizeChange,
                "current-change": _vm.currentChange,
                "row-update": _vm.update,
                "row-save": _vm.create,
              },
              scopedSlots: _vm._u([
                {
                  key: "dsScopeForm",
                  fn: function (ref) {
                    return [
                      _vm.form.dsType === 1
                        ? _c(
                            "div",
                            [
                              _c("el-tree", {
                                ref: "scopeTree",
                                staticClass: "filter-tree",
                                attrs: {
                                  data: _vm.dsScopeData,
                                  "check-strictly": true,
                                  props: _vm.defaultProps,
                                  "default-checked-keys": _vm.checkedDsScope,
                                  "node-key": "id",
                                  "highlight-current": "",
                                  "show-checkbox": "",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "menu",
                  fn: function (scope) {
                    return [
                      _vm.roleManager_btn_edit && _vm.rolesCode === "admin"
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleUpdate(
                                    scope.row,
                                    scope.index
                                  )
                                },
                              },
                            },
                            [_vm._v("编辑\n        ")]
                          )
                        : _vm._e(),
                      _vm.roleManager_btn_del && _vm.rolesCode === "admin"
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(
                                    scope.row,
                                    scope.index
                                  )
                                },
                              },
                            },
                            [_vm._v("删除\n        ")]
                          )
                        : _vm._e(),
                      _vm.roleManager_btn_perm
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handlePermission(
                                    scope.row,
                                    scope.index
                                  )
                                },
                              },
                            },
                            [_vm._v("权限\n        ")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.form,
                callback: function ($$v) {
                  _vm.form = $$v
                },
                expression: "form",
              },
            },
            [
              _c(
                "template",
                { slot: "menuLeft" },
                [
                  _vm.roleManager_btn_add
                    ? _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: { type: "primary", icon: "el-icon-edit" },
                          on: { click: _vm.handleCreate },
                        },
                        [_vm._v("添加\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          ),
          _c("excel-upload", {
            ref: "excelUpload",
            attrs: {
              title: "角色信息导入",
              url: "/admin/role/import",
              "temp-name": "角色信息.xlsx",
              "temp-url": "/admin/sys-file/local/file/role.xlsx",
            },
            on: { refreshDataList: _vm.handleRefreshChange },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogPermissionVisible,
            "close-on-click-modal": false,
            title: "分配权限",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogPermissionVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-main-tree" },
            [
              _c("el-tree", {
                ref: "menuTree",
                staticClass: "filter-tree",
                attrs: {
                  data: _vm.treeData,
                  "default-checked-keys": _vm.checkedKeys,
                  "check-strictly": false,
                  props: _vm.defaultProps,
                  "filter-node-method": _vm.filterNode,
                  "node-key": "id",
                  "highlight-current": "",
                  "show-checkbox": "",
                  "default-expand-all": "",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.updatePermession(_vm.roleId)
                    },
                  },
                },
                [_vm._v("更 新\n      ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "default", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.cancal()
                    },
                  },
                },
                [_vm._v("取消\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }